import m from "../../node_modules/classnames/index.js";
import { jsx as i } from "../../_virtual/jsx-runtime.js";
function s({
  className: o,
  children: r
}) {
  return /* @__PURE__ */ i("div", {
    className: m("form-grid__notice", o),
    children: r
  });
}
export {
  s as FormNotice
};
//# sourceMappingURL=FormNotice.js.map
